import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "video-card__wrap" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "video-card__img-box" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "video-card__video-title" }
const _hoisted_6 = { class: "video-card__img-box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "video-card__video-title" }

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import VideoPlayer from '@/components/VideoPlayer/index.vue';
import { ManualViewTypeEnum, MediaFile } from '@/types/manuals';


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoCard',
  props: {
    card: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const isLink = (item: MediaFile) => item.view_type === ManualViewTypeEnum.open;
const currentLocaleIndex = computed(() => store.getters['Locales/currentLocaleIndex']);

const file = computed(() => `${props.card.locales[currentLocaleIndex.value]?.file}#t=0.001`);
const text = computed(() => props.card.locales[currentLocaleIndex.value]?.caption);

const isClickActive = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-card", { 'video-card_click-active': isClickActive.value }]),
    onMousedown: _cache[0] || (_cache[0] = ($event: any) => (isClickActive.value = true)),
    onMouseup: _cache[1] || (_cache[1] = ($event: any) => (isClickActive.value = false)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isClickActive.value = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (isLink(_ctx.card))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: file.value,
            class: "video-card__link",
            target: "_blank"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: "/img/empty/placeholderBg.webp",
                alt: text.value,
                class: "video-card__img"
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("h3", _hoisted_5, _toDisplayString(text.value), 1)
          ], 8, _hoisted_2))
        : (_openBlock(), _createBlock(VideoPlayer, {
            key: 1,
            path: file.value,
            title: text.value,
            autoplay: true,
            width: "70%",
            openButtonCssClass: "video-card__btn",
            openButtonText: text.value
          }, {
            "video-preview": _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("video", {
                  src: file.value,
                  preload: "metadata",
                  class: "video-card__img"
                }, null, 8, _hoisted_7),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "video-card__img-circle" }, null, -1))
              ])
            ]),
            "btn-text": _withCtx(() => [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(text.value), 1)
            ]),
            _: 1
          }, 8, ["path", "title", "openButtonText"]))
    ])
  ], 34))
}
}

})